/** @type {import('../help-index.js').HelpSidebarItem} */
export const MET_SUB_SUMMARY_ITEM = {
  id: 'subscriptions_summary',
  screenId: 'met-sub-summary',
  label: 'Resumen',
  description: 'Cartera activa, MRR, altas/bajas y facturación de cuotas del período.',
  detail: {
    sections: [
      {
        title: 'Para qué sirve',
        intro:
          'Vista rápida del negocio de suscripciones: contratos activos, ingreso recurrente mensualizado (MRR), altas y bajas del período, cuotas facturadas y efecto de bonificaciones.',
      },
      {
        title: 'Paso 1 — Elegir período',
        bullets: [
          'Usá los atajos Hoy, Semana, Mes, Mes anterior o Personalizado (desde / hasta + Aplicar).',
          'Las altas, bajas y cuotas se miden en ese rango. El MRR y los contratos activos son un corte de la cartera actual.',
        ],
      },
      {
        title: 'Paso 2 — Leer indicadores',
        bullets: [
          'Contratos activos y suscriptores — tamaño de la cartera.',
          'MRR / ARR — ingreso recurrente de la cartera activa llevado a base mensual / anual (no es lo facturado del período).',
          'Altas / bajas y fuga aproximada (churn) — % de bajas del período sobre los contratos que ya estaban activos al inicio (aproximación).',
          'Cuotas del período — importe facturado y cobrado de las cuotas generadas.',
          'Bonificaciones vigentes — grants activos y descuento estimado por período.',
          'Gráficos: mix de ingreso recurrente mensual por plan y evolución de facturación vs cobro.',
        ],
      },
    ],
  },
}
